import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CompaniesService, Company } from 'src/app/core/companies.service';
import { CompanyContract, CompanyContractsService } from 'src/app/core/company-contracts.service';
import {
  CompanyQineticPaymentSource,
  CompanyQineticPaymentSourceService,
} from 'src/app/core/company-qinetic-payment-source.service';
import {
  CompanyStripePaymentSource,
  CompanyStripePaymentSourceService,
} from 'src/app/core/company-stripe-payment-source.service';
import { ErrorService } from 'src/app/core/error.service';
import { LongRange, LongRangeService } from 'src/app/core/long-range.service';

@Component({
  selector: 'app-company-details-general',
  templateUrl: './company-details-general.component.html',
  styleUrls: ['./company-details-general.component.scss'],
})
export class CompanyDetailsGeneralComponent {
  @Input() company_id?: string | null;
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();

  company?: Company;
  qinetic_payment_sources?: CompanyQineticPaymentSource[];
  stripe_payment_sources?: CompanyStripePaymentSource[];
  contracts?: CompanyContract[];
  default_long_ranges?: LongRange[];
  company_long_ranges?: LongRange[];
  is_read_running = false;
  is_qinetic_ps_list_running = false;
  is_stripe_ps_list_running = false;
  is_list_running: boolean = false;

  constructor(
    private companies_service: CompaniesService,
    private error_service: ErrorService,
    private company_qinetic_payment_source_service: CompanyQineticPaymentSourceService,
    private company_stripe_payment_source_service: CompanyStripePaymentSourceService,
    private company_contracts_service: CompanyContractsService,
    private long_range_service: LongRangeService,
  ) { }

  ngOnInit(): void {
    this.company = undefined;
    this.company_long_ranges = [];
    this.default_long_ranges = [];
    this.readCompany(this.company_id as string);
    this.qinetic_payment_sources = [];
    this.listQineticPaymentSources(this.company_id as string);
    this.stripe_payment_sources = [];
    this.listStripePaymentSources(this.company_id as string);
    this.contracts = [];
    this.listContracts(this.company_id as string);
  }

  onRefresh(): void {
    this.company = undefined;
    this.readCompany(this.company_id as string);
    this.qinetic_payment_sources = [];
    this.listQineticPaymentSources(this.company_id as string);
    this.stripe_payment_sources = [];
    this.listStripePaymentSources(this.company_id as string);
    this.contracts = [];
    this.listContracts(this.company_id as string);
  }

  readCompany(company_id: string): void {
    this.is_read_running = true;
    this.companies_service.readCompany(company_id).subscribe({
      next: response => {
        this.company = response.data;
        this.company_long_ranges = this.orderLongRange(this.company?.long_ranges || []);
        this.listLongRanges();
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_read_running = false;
      },
    });
  }

  listQineticPaymentSources(company_id: string): void {
    this.is_qinetic_ps_list_running = true;
    this.company_qinetic_payment_source_service.listCompanyQineticPaymentSources(company_id).subscribe({
      next: repsonse => {
        this.qinetic_payment_sources = repsonse.data;
        this.is_qinetic_ps_list_running = false;
      },
      error: error => {
        this.is_qinetic_ps_list_running = false;
      },
    });
  }

  listStripePaymentSources(company_id: string): void {
    this.is_stripe_ps_list_running = true;
    this.company_stripe_payment_source_service.listCompanyStripePaymentSources(company_id).subscribe({
      next: repsonse => {
        this.stripe_payment_sources = repsonse.data;
        this.is_stripe_ps_list_running = false;
      },
      error: error => {
        this.is_stripe_ps_list_running = false;
      },
    });
  }

  listContracts(company_id: string): void {
    this.is_list_running = true;
    this.company_contracts_service.listCompanyContracts(company_id).subscribe({
      next: response => {
        this.contracts = response.data;
        this.is_list_running = false;
      },
      error: error => {
        this.is_list_running = false;
      },
    });
  }

  listLongRanges(): void {
    this.is_read_running = true;
    this.long_range_service.list().subscribe({
      next: response => {
        this.default_long_ranges = this.filterDefaultLongRanges(response.data);
        this.is_read_running = false;
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_read_running = false;
      },
    });
  }

  orderLongRange(long_ranges: LongRange[]): LongRange[] {
    return long_ranges.sort(this.compareLongRange);
  }

  compareLongRange(a: LongRange, b: LongRange): number {
    if (a.min_amount && b.min_amount && a.min_amount < b.min_amount) {
      return -1;
    }
    if (a.min_amount && b.min_amount && a.min_amount > b.min_amount) {
      return 1;
    }
    return 0;
  }

  filterDefaultLongRanges(default_long_ranges: LongRange[]): LongRange[] {
    if (!this.company?.order_requirements?.is_bnpl_long_enabled) {
      // Remove 600-1000 long range with 6, 8, 10, and 12 steps if BNPL Long is not enabled for the company
      return default_long_ranges.map(dlr => {
        if (dlr.min_amount === 600 && dlr.max_amount === 1000) {
          return {
            ...dlr,
            allowed_steps: dlr.allowed_steps?.filter(step => ![6, 8, 10, 12].includes(step)),
          };
        }
        return dlr;
      });
    }
    return default_long_ranges;
  }
}
